import { render, staticRenderFns } from "./JobRecommand.vue?vue&type=template&id=722c26f4&"
import script from "./JobRecommand.vue?vue&type=script&lang=js&"
export * from "./JobRecommand.vue?vue&type=script&lang=js&"
import style0 from "./JobRecommand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports